import ListNumberedIcon from '@atlaskit/icon/core/list-numbered';
import React from 'react';

export const SvgNumberedList = () => (
  <ListNumberedIcon label="" testId="ads-refreshed-icon" />
);
